import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';

const TestimonialFeatured: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const variant = c.background_variant || c.variant || 'light';

  const bgColor =
    variant === 'primary'  ? 'var(--brand-primary, #1a365d)' :
    variant === 'gradient' ? 'linear-gradient(135deg, var(--brand-primary, #1a365d) 0%, var(--brand-secondary, #2563eb) 100%)' :
    '#fff';

  const textColor   = variant === 'light' ? '#0f172a' : '#fff';
  const quoteColor  = variant === 'light' ? 'var(--brand-primary, #2563eb)' : 'rgba(255,255,255,0.25)';
  const metaColor   = variant === 'light' ? 'var(--brand-text-light, #64748b)' : 'rgba(255,255,255,0.65)';

  return (
    <section
      className="sb-render sb-render-testimonial-featured"
      style={{
        padding: '96px 24px',
        background: bgColor,
        color: textColor,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative large quote mark */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: 32,
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: '18rem',
          lineHeight: 1,
          color: quoteColor,
          fontFamily: 'Georgia, serif',
          userSelect: 'none',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      >
        "
      </div>

      <div style={{ maxWidth: 760, margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 1 }}>
        {/* Quote */}
        <InlineEditText
          tag="p"
          controlKey="quote"
          style={{
            fontSize: '1.875rem',
            fontWeight: 600,
            lineHeight: 1.45,
            fontStyle: 'italic',
            color: textColor,
            margin: '0 0 40px',
            quotes: 'none',
          }}
        >
          {c.quote || 'This product changed everything for us. Exceptional quality and service from start to finish.'}
        </InlineEditText>

        {/* Avatar + meta */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
          {(c.author_image || c.avatar_url) ? (
            <img
              src={c.author_image || c.avatar_url}
              alt={c.author_name || c.author || 'Testimonial author'}
              style={{
                width: 72,
                height: 72,
                borderRadius: '50%',
                objectFit: 'cover',
                border: variant === 'light' ? '3px solid var(--brand-primary, #2563eb)' : '3px solid rgba(255,255,255,0.4)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              }}
            />
          ) : (
            <div style={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              background: variant === 'light' ? '#e2e8f0' : 'rgba(255,255,255,0.15)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '2rem',
              color: metaColor,
            }}>
              👤
            </div>
          )}

          <div>
            <InlineEditText
              tag="p"
              controlKey="author_name"
              style={{ fontWeight: 700, fontSize: '1rem', color: textColor, margin: '0 0 2px' }}
            >
              {c.author_name || c.author || 'Jane Smith'}
            </InlineEditText>
            <p style={{ fontSize: '0.875rem', color: metaColor, margin: 0 }}>
              {[c.author_role || c.role, c.author_company || c.company].filter(Boolean).join(', ') || 'CEO, Example Co.'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialFeatured;
